<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
    <!-- Your contet -->
    <v-parallax src="/static/full-bg-9.jpg"  >
    
    <v-layout
      align-center
      column
      justify-center
    >
      <div class="display-4 white--text bold mb-5">Securyty</div>
      <div class="subheading blue--text bold ">Start using SECURYTY today to automate processes, streamline closing contracts <br> and maximize the ROI from the digitization process.</div>
    </v-layout>    
    
    </v-parallax>
    <div class="display-3 grey--text text--darken-1">Electronic signature and identification</div>
    <div
      class="title grey--text text--darken-1"
    >Securyty provides a set of trust services to improve the legal security of all your digital communications and transactions.</div>

    <v-layout>
      <v-flex>
        <v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md6 lg4>
                <v-card flat tile>
                  <v-img
                    src="/static/electronicsignature.png"
                    aspect-ratio="2.75"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">Electronic Signature</h3>
                      <div>
Also referred to as an E-signature or eSignature, it is an electronic marker that indicates that a person is agreeing or approving a contract or the contents of a document 
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange" to="/blank-page" >Legal</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg4>
                <v-card flat tile>
                  <v-img
                    src="/static/certemail.svg"
                    aspect-ratio="2.75"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Certified Notification</h3>
                      <div>
                        Guaranteed electronic communications with traceability of the delivery and its reading, and certifying all the content. 
                        <br />Send notifications for a fraction of your current costs 
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange" to="/blank-page" >Legal</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>


      <!-- --------------- -->

      <v-flex xs12 md6 lg4>
        <v-card flat tile>
          <v-img src="/static/videoonboarding.png" aspect-ratio="2.75"></v-img>

          <v-card-title primary-title xs12 sm3>
            <div>
              <h3 class="headline mb-0">Video Identification</h3>
              <div>
                Verify the identity of your customers remotely and in an unattended way
                <br />Check faces and documents validity
              </div>
            </div>
          </v-card-title>

          <v-card-actions style="padding-left: 50%;">
            <v-btn flat color="orange">Share</v-btn>
            <v-btn flat color="orange" to="/blank-page" >Legal</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
                  </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
    <v-parallax src="/static/facial-recognition-data-points.jpg">
        <v-layout
      align-center
      column
      justify-center
    >
      <div class="display-4 white--text bold mb-4">Video Identification</div>
      <div class="subheading white--text bold ">Start using SECURYTY today to get your customers on board<br> and maximize the ROI from the digitization process.</div>
    </v-layout>  
    </v-parallax>
  </v-container>
</template>
<script>
export default {
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      page: {
        title: "Securyty",
        headline: "Securyty ",
        description: `Your partner for digitalization`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ]
    };
  }
};
</script>
